import { useNavigate } from "react-router-dom";
import { useModalStore } from "../../../store/report/modalStore";
import DropDownWithPortal from "../../UI/DropDownWithPortal";

interface PinCardActionMenuProps {
  pinId: string;
  displayName: string;
  reportId: string;
  disabled?: boolean;
}

const PinCardActionMenu = ({
  pinId,
  displayName,
  reportId,
  disabled = false,
}: PinCardActionMenuProps) => {
  const navigate = useNavigate();
  const openModal = useModalStore((s) => s.openModal);

  const closeMenu = () =>
    document.dispatchEvent(
      new CustomEvent("closeOtherDropdowns", {
        detail: { dropdownId: "close-all" },
      }),
    );

  const handleAction = (fn: () => void) => {
    fn();
    closeMenu();
  };

  const options = [
    {
      label: "Rename",
      onClick: () =>
        handleAction(() => openModal("renamePin", { pinId, displayName })),
    },
    {
      label: "Go to Report",
      onClick: () => handleAction(() => navigate(`/reports/${reportId}`)),
    },
    {
      label: "Remove from Dashboard",
      onClick: () => handleAction(() => openModal("removePin", { pinId })),
    },
  ];

  return <DropDownWithPortal id={`dashboard-pin-${pinId}`} options={options} disabled={disabled} />;
};

export default PinCardActionMenu;
